// extracted by mini-css-extract-plugin
module.exports = {"card":"Booking_card__3VjZh","header":"Booking_header__2Z-DS"};